import script from "./CookieNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieNotice.vue?vue&type=script&setup=true&lang=js"

import "./CookieNotice.vue?vue&type=style&index=0&id=6f32c2e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f32c2e4"]])

export default __exports__